export default "__VITE_ASSET__ddfa80f0__"